/* import __COLOCATED_TEMPLATE__ from './line-preview.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  hasSessions: boolean;
  verboseLogsEnabled: boolean;
  copyLatestSessionId: () => Promise<void>;
  toggleVerboseLogsEnabled: () => void;
  reportIssue: () => void;
  goToVoiceTesting: () => void;
}

interface Signature {
  Args: Args;
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const LinePreview = templateOnlyComponent<Signature>();
export default LinePreview;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Deploy::Voice::LinePreview': typeof LinePreview;
  }
}
